module.exports = __webpack_public_path__ + "img/graph2.5e89a8e9.png";